import React from "react";
import Sidebar from "../../DesignSystem/Sidebar";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { storage } from "../../../backend/firebaseConfig";
import { listAll, getDownloadURL, ref } from "firebase/storage";
import { auth } from "../../../backend/firebaseConfig";
import PortalCard from "../../DesignSystem/Cards/PortalCard";
import "../../../css/Compliance/MembersHub/FileDirectory.css";
import { uploadBytesResumable } from "firebase/storage";
import { deleteObject } from "firebase/storage";
import { uploadBytes } from "firebase/storage";
import {
  faTrash,
  faPlusCircle,
  faFolderPlus,
  faFolderMinus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import ButtonYellow from "../../DesignSystem/Buttons/ButtonYellow";
import ButtonYellowSmall from "../../DesignSystem/Buttons/ButtonSmall";
import { doc, updateDoc, arrayUnion, getDoc } from "firebase/firestore";
import { db } from "../../../backend/firebaseConfig";
import InputField from "../../DesignSystem/Inputs/InputField";
import Breadcrumb from "../../DesignSystem/Breadcrumb/Breadcrumb";

// --- fast natural sort + lazy URL open ---
const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });
const stripExt = (s = "") => s.replace(/\.[^.]+$/, "");
const urlCache = new Map();

const openFileRef = async (itemRef) => {
  try {
    const key = itemRef.fullPath;
    let url = urlCache.get(key);
    if (!url) {
      url = await getDownloadURL(itemRef);
      urlCache.set(key, url);
    }
    window.open(url, "_blank", "noopener,noreferrer");
  } catch (e) {
    // console.error("Failed to open file:", itemRef?.fullPath, e);
  }
};


const MembersHub = () => {
  const { folderName = "" } = useParams(); // Get the folder name from the route
  const [directory, setDirectory] = useState({ subfolders: [], files: [] });
  const [isLoading, setIsLoading] = useState(true);
  const initialPath = `MembersHub/${folderName}`;
  const [newSubfolderName, setNewSubfolderName] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  // const [rootSubfolderName, setRootSubfolderName] = useState("GDPR");
  // const [rootSelectedFiles, setRootSelectedFiles] = useState([]);
  const navigate = useNavigate();
  const [showSubfolderInput, setShowSubfolderInput] = useState(false);
  const [subfolderParentPath, setSubfolderParentPath] = useState("");
  const [deleteFile, setDeleteFile] = useState(null);
  const [deleteFolder, setDeleteFolder] = useState(null);
  const [isDeleteFileModalOpen, setIsDeleteFileModalOpen] = useState(false);
  const [isDeleteFolderModalOpen, setIsDeleteFolderModalOpen] = useState(false);

  const handleCreateSubfolder = async (parentPath, selectedFiles) => {
    const subfolderName = newSubfolderName;
    const filesToUpload = selectedFiles;

    // 🔹 Fix: Ensure Correct Folder Path
    const folderPath = `${parentPath}/${newSubfolderName}`; // Creating in the root

    // console.log("Creating folder at path:", folderPath);

    try {
      // Upload selected files into the new subfolder
      const uploadPromises = filesToUpload.map((file) => {
        const filePath = `${folderPath}/${file.name}`;
        const fileRef = ref(storage, filePath);
        return uploadBytes(fileRef, file);
      });

      await Promise.all(uploadPromises);

      await addActivityLog(
        "Created Subfolder",
        folderPath,
        filesToUpload.map((f) => f.name)
      );

      // Reset Inputs & Refresh UI
      setNewSubfolderName("");
      setSelectedFiles([]);
      setShowSubfolderInput(false);
      await refreshDirectory(parentPath || "MembersHub"); // Refresh UI
    } catch (error) {
      // console.error("Error creating subfolder:", error);
    }
  };

  const handleDeleteFile = async (filePath, fileName) => {
    const fileRef = ref(storage, filePath + "/" + fileName);

    try {
      await deleteObject(fileRef);
      await refreshDirectory();
      await addActivityLog("Deleted File", filePath, [fileName]);
    } catch (error) {
      // console.error("Error deleting file:", error);
    }
  };

  const handleFileUpload = async (event, targetPath) => {
    const files = Array.from(event.target.files);
    if (!files.length) return;

    try {
      // Upload all selected files to the specified folder
      const uploadPromises = files.map((file) => {
        const fullPath = targetPath
          ? `${targetPath}/${file.name}`
          : `MembersHub/${folderName}/${file.name}`;

        const fileRef = ref(storage, fullPath);
        return uploadBytesResumable(fileRef, file);
      });

      await Promise.all(uploadPromises);
      await addActivityLog(
        "Uploaded Files",
        targetPath,
        files.map((f) => f.name)
      );

      await refreshDirectory(); // Refresh UI after upload
    } catch (error) {
      // console.error("File upload failed:", error);
    }
  };

  const handleDeleteFolder = async (folderPath) => {
    const folderRef = ref(storage, folderPath);

    try {
      const folderContents = await listAll(folderRef);

      // Delete all files inside folder
      const deleteFilePromises = folderContents.items.map((fileRef) =>
        deleteObject(fileRef)
      );
      await Promise.all(deleteFilePromises);
      await addActivityLog("Deleted Folder", folderPath);

      await refreshDirectory();
    } catch (error) {
      // console.error("Error deleting folder:", error);
    }
  };

  const addActivityLog = async (actionType, folderPath, fileNames = []) => {
    try {
      const activityRef = doc(db, "Compliance", "Members Hub");
      const activityDoc = await getDoc(activityRef);

      const newLog = {
        action: actionType, // "Created Subfolder", "Deleted File", etc.
        folder: folderPath,
        files: fileNames, // Array of file names if applicable
        postedBy: auth.currentUser?.displayName || "Unknown User",
        postedOn: new Date(),
      };

      if (activityDoc.exists()) {
        // Get the existing activity array
        const existingActivity = activityDoc.data().activity || [];

        // Store latest update on TOP
        const updatedActivity = [newLog, ...existingActivity];

        // Update Firestore with the new ordered array
        await updateDoc(activityRef, { activity: updatedActivity });
      } else {
        // If no activity log exists, create a new one
        await updateDoc(activityRef, { activity: [newLog] });
      }

      // console.log("Activity log added:", newLog);
    } catch (error) {
      // console.error("Error adding activity log:", error);
    }
  };

  const fetchFolderData = async (location) => {
    const folderRef = ref(storage, location);

    try {
      const folderContents = await listAll(folderRef);

      // Recurse subfolders in parallel
      const subfolders = await Promise.all(
        folderContents.prefixes.map(async (prefix) => {
          const subfolderPath = `${location}/${prefix.name}`;
          const subfolderData = await fetchFolderData(subfolderPath);
          return {
            name: prefix.name,
            path: subfolderPath,
            content: subfolderData,
          };
        })
      );
      // natural sort subfolders
      subfolders.sort((a, b) => collator.compare(a.name, b.name));

      // Keep refs (no URL yet); natural sort by display name
      const files = folderContents.items
        .map((itemRef) => ({
          name: itemRef.name,
          ref: itemRef,
          path: location,
        }))
        .sort((a, b) => collator.compare(stripExt(a.name), stripExt(b.name)));

      return { subfolders, files };
    } catch (error) {
      // console.error("Error fetching folder data:", error);
      return { subfolders: [], files: [] };
    }
  };

  const refreshDirectory = async () => {
    setIsLoading(true);
    const updatedData = await fetchFolderData(initialPath);
    setDirectory(updatedData);
    setSelectedFiles([]); // Clear selected files
    setIsLoading(false);
  };

  useEffect(() => {
    setIsLoading(true); // Start loading
    fetchFolderData(initialPath)
      .then((data) => setDirectory(data))
      .finally(() => setIsLoading(false)); // End loading
  }, [folderName]);

  // Render directory recursively
  const renderDirectory = (directory, level = 0, currentPath = "", name) => {
    currentPath = currentPath || initialPath;
    return (
      <div>
        {directory.files.length > 0 && (
          <div className="File-Directory-Container-SubFolderTitle">
            <h4>
              {name || folderName}
              <div className="Content-Small">{currentPath}</div>
            </h4>

              <div className="File-Directory-Container-SubFolder">
                {directory.files.map((file) => (
                  <div key={file.name} className="file-container">
                    <FontAwesomeIcon
                      className="PortalCardIcon"
                      icon={faTrash}
                      onClick={() => {
                        setDeleteFile({ path: file.path, name: file.name });
                        setIsDeleteFileModalOpen(true);
                      }}
                    />
                    {/* Lazy open on click (no URL prefetch) */}
                    <PortalCard
                      title={stripExt(file.name)}
                      onClick={() => openFileRef(file.ref)}
                    />
                  </div>
                ))}
              </div>
            <div className="File-Directory-Container-SubFolder">
              <div className="add-file">
                <input
                  type="file"
                  multiple
                  style={{ display: "none" }}
                  onChange={(e) => handleFileUpload(e, currentPath)}
                  id={`fileUpload-${currentPath}`}
                />
                <label
                  htmlFor={`fileUpload-${currentPath}`}
                  className="add-icon-label"
                >
                  <FontAwesomeIcon
                    className="AddFileIcon"
                    icon={faPlusCircle}
                    title={`Click to upload files to the ${
                      name || folderName
                    } folder`}
                  />
                </label>
              </div>

              <FontAwesomeIcon
                className="AddFileIcon"
                icon={faFolderPlus}
                title={`Click to create a subfolder in the ${
                  name || folderName
                } folder`}
                onClick={() => {
                  setShowSubfolderInput(!showSubfolderInput);
                  setSubfolderParentPath(currentPath);
                  // console.log(currentPath);
                }} // Toggle input visibility
              />
              {showSubfolderInput && (
                <div className="modal-overlay">
                  <div className="modal-content">
                    <h3>Create a Subfolder</h3>
                    <InputField
                      title="Subfolder Name*"
                      placeholder="Enter subfolder name"
                      value={newSubfolderName}
                      onChange={(e) => setNewSubfolderName(e.target.value)}
                    />
                    <div className="add-file">
                      {/* Hidden File Input (Correctly Linked) */}
                      <input
                        type="file"
                        multiple
                        style={{ display: "none" }}
                        id="fileUpload"
                        onChange={(e) => {
                          const files = Array.from(e.target.files);
                          // console.log("Selected Files:", files); // Debugging
                          setSelectedFiles(files);
                        }}
                      />

                      {/* Label Clicking the File Input */}
                      <label htmlFor="fileUpload" className="add-icon-label">
                        <FontAwesomeIcon
                          className="AddFileIcon"
                          icon={faPlusCircle}
                          title={`Click to upload files to the ${
                            name || folderName
                          } folder`}
                        />
                      </label>
                    </div>

                    {/* Display Selected Files for Debugging */}
                    {selectedFiles.length > 0 && (
                      <div className="MembersHubSelectedFiles">
                        <div className="Content">Selected Files:</div>
                        <div className="Content">
                          {selectedFiles.map((file, index) => (
                            <div key={index}>{file.name}</div>
                          ))}
                        </div>
                      </div>
                    )}

                    <div className="modal-buttons">
                      <ButtonYellow
                        buttonText="Add Subfolder"
                        onClick={() => {
                          if (
                            !newSubfolderName.trim() ||
                            selectedFiles.length === 0
                          ) {
                            alert(
                              "Please enter a folder name and select at least one file."
                            );
                          } else {
                            handleCreateSubfolder(
                              subfolderParentPath,
                              selectedFiles
                            );
                            setNewSubfolderName(""); // Clear input
                            setSelectedFiles([]); // Clear files
                            setShowSubfolderInput(false);
                          }
                        }}
                      />

                      <CloseIcon
                        className="close-icon"
                        onClick={() => {
                          setShowSubfolderInput(false);
                          setNewSubfolderName("");
                          setSelectedFiles([]);
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* <input
                type="file"
                multiple
                onChange={(e) => setSelectedFiles(Array.from(e.target.files))}
              /> */}

              {name && (
                <FontAwesomeIcon
                  className="AddFileIcon"
                  icon={faFolderMinus}
                  title={`Click to delete the ${name} folder`}
                  onClick={() => {
                    // handleDeleteFolder(currentPath)
                    setDeleteFolder({ path: currentPath, name });
                    setIsDeleteFolderModalOpen(true);
                  }}
                />
              )}
              {/* Delete File Confirmation Popup */}
              {isDeleteFileModalOpen && (
                <div className="modal-overlay">
                  <div className="modal-content">
                    <CloseIcon
                      className="close-icon"
                      onClick={() => setIsDeleteFileModalOpen(false)}
                    />
                    <h3>Delete File</h3>
                    <div className="Content">
                      Are you sure you want to delete{" "}
                      <span className="Content-SemiBold">
                        {deleteFile?.name}
                      </span>{" "}
                      ?
                    </div>
                    <ButtonYellowSmall
                      buttonText="Yes"
                      onClick={() => {
                        handleDeleteFile(deleteFile.path, deleteFile.name);
                        setIsDeleteFileModalOpen(false);
                        setDeleteFile(null);
                      }}
                    />
                  </div>
                </div>
              )}

              {/* Delete Folder Confirmation Popup */}
              {isDeleteFolderModalOpen && (
                <div className="modal-overlay">
                  <div className="modal-content">
                    <CloseIcon
                      className="close-icon"
                      onClick={() => setIsDeleteFolderModalOpen(false)}
                    />
                    <h3>Delete Folder</h3>
                    <div className="Content">
                      Are you sure you want to delete the{" "}
                      <span className="Content-SemiBold">
                        {deleteFolder?.name}
                      </span>{" "}
                      folder and all its contents ?
                    </div>
                    <ButtonYellowSmall
                      buttonText="Yes"
                      onClick={() => {
                        handleDeleteFolder(deleteFolder.path);
                        setIsDeleteFolderModalOpen(false);
                        setDeleteFolder(null);
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Display subfolders inside the current directory */}
        {directory.subfolders.map((subfolder) => (
          <div key={subfolder.name} className="subfolder-group">
            {/* <input
              type="text"
              placeholder="Enter subfolder name"
              value={newSubfolderName}
              onChange={(e) => setNewSubfolderName(e.target.value)}
            />
            <input
              type="file"
              multiple
              onChange={(e) => setSelectedFiles(Array.from(e.target.files))}
            />
            <button
              onClick={() => {
                handleCreateSubfolder(subfolder.path, selectedFiles);
                setNewSubfolderName(""); // Clear input after creating subfolder
                setSelectedFiles([]); // Clear selected files
              }}
            >
              Add Sub Folder
            </button> */}

            {/* Recursively render subfolders */}
            {renderDirectory(
              subfolder.content,
              level + 1,
              subfolder.path,
              subfolder.name
            )}
          </div>
        ))}
      </div>
    );
  };

  useEffect(() => {
    if (!auth.currentUser) {
      navigate("/"); // Redirect to Sign-In if not authenticated
    }
  }, []);

  return (
    <div className="Main-Page">
      <Sidebar />
      <div className="MembersHub-Contanier">
        <div className="MembersHub-Breadcrumb">
          <Breadcrumb
            items={[
              {
                label: "Compliance",
                to: "/Department/Compliance",
              },
              ...(folderName
                ? [
                    { label: "Members Hub", to: "/MembersHub" },
                    { label: folderName },
                  ]
                : [{ label: "Members Hub" }]),
            ]}
          />
        </div>
        <h2>{folderName || "Members Hub"}</h2>

        {/* Root-Level File Upload */}
        {/* <div className="root-file-upload">
          <input
            type="file"
            multiple
            onChange={(e) => setSelectedFiles(Array.from(e.target.files))}
          />
          <button
            onClick={() => {
              handleFileUpload(
                { target: { files: rootSelectedFiles } },
                `MembersHub/${folderName}`
              );
              setRootSelectedFiles([]);
            }}
          >
            Upload Files to Root
          </button>
        </div> */}

        {/* Root-Level Subfolder Creation */}
        {/* <div className="root-folder-creation">
          <input
            type="text"
            placeholder="Enter subfolder name"
            value={rootSubfolderName}
            onChange={(e) => setRootSubfolderName(e.target.value)}
          />
          <input
            type="file"
            multiple
            onChange={(e) => setRootSelectedFiles(Array.from(e.target.files))}
          />
          <button
            onClick={() => {
              handleCreateSubfolder(
                `MembersHub/${folderName}`,
                rootSelectedFiles
              );
              setRootSubfolderName("");
              setRootSelectedFiles([]);
            }}
          >
            Create Root Subfolder
          </button>
        </div> */}

        <>
          {isLoading ? (
            <div className="spinner-container">
              <div className="spinner"></div>
              <div className="Content-Small">Loading files...</div>
            </div>
          ) : (
            <>
              {/* 🔹 Always show "Add File" & "Add Folder" options */}

              {directory.files.length <= 0 && (
                <div className="File-Directory-Container-SubFolder">
                  <div className="add-file">
                    <input
                      type="file"
                      multiple
                      style={{ display: "none" }}
                      id="rootFileUpload"
                      onChange={(e) =>
                        handleFileUpload(e, `MembersHub/${folderName}`)
                      }
                    />
                    <label htmlFor="rootFileUpload" className="add-icon-label">
                      <FontAwesomeIcon
                        className="AddFileIcon"
                        icon={faPlusCircle}
                        title={`Click to upload files to ${
                          folderName || "Root"
                        }`}
                      />
                    </label>
                  </div>

                  <FontAwesomeIcon
                    className="AddFileIcon"
                    icon={faFolderPlus}
                    title={`Click to create a subfolder in ${
                      folderName || "Root"
                    }`}
                    onClick={() => {
                      setShowSubfolderInput(true);
                      setSubfolderParentPath(`MembersHub/${folderName}`);
                    }}
                  />
                </div>
              )}
              {/* 🔹 Only Render Directory If Files or Folders Exist */}
              {directory.subfolders.length > 0 || directory.files.length > 0 ? (
                renderDirectory(directory)
              ) : (
                <div className="Content-Large">
                  No files or folders found in this directory.
                </div>
              )}

              {/* 🔹 Show Subfolder Popup */}
              {showSubfolderInput && (
                <div className="modal-overlay">
                  <div className="modal-content">
                    <h3>Create a Subfolder</h3>
                    <InputField
                      title="Subfolder Name*"
                      placeholder="Enter subfolder name"
                      value={newSubfolderName}
                      onChange={(e) => setNewSubfolderName(e.target.value)}
                    />
                    <div className="add-file">
                      <input
                        type="file"
                        multiple
                        style={{ display: "none" }}
                        id="fileUpload"
                        onChange={(e) => {
                          const files = Array.from(e.target.files);
                          // console.log("Selected Files:", files); // Debugging
                          setSelectedFiles(files);
                        }}
                      />
                      <label htmlFor="fileUpload" className="add-icon-label">
                        <FontAwesomeIcon
                          className="AddFileIcon"
                          icon={faPlusCircle}
                          title={`Click to upload files to the ${folderName} folder`}
                        />
                      </label>
                    </div>

                    {/* Display Selected Files */}
                    {selectedFiles.length > 0 && (
                      <div className="MembersHubSelectedFiles">
                        <div className="Content">Selected Files:</div>
                        <div className="Content">
                          {selectedFiles.map((file, index) => (
                            <div key={index}>{file.name}</div>
                          ))}
                        </div>
                      </div>
                    )}

                    <div className="modal-buttons">
                      <ButtonYellow
                        buttonText="Add Subfolder"
                        onClick={() => {
                          if (
                            !newSubfolderName.trim() ||
                            selectedFiles.length === 0
                          ) {
                            alert(
                              "Please enter a folder name and select at least one file."
                            );
                          } else {
                            handleCreateSubfolder(
                              subfolderParentPath,
                              selectedFiles
                            );
                            setNewSubfolderName(""); // Clear input
                            setSelectedFiles([]); // Clear files
                            setShowSubfolderInput(false);
                          }
                        }}
                      />
                      <CloseIcon
                        className="close-icon"
                        onClick={() => {
                          setShowSubfolderInput(false);
                          setNewSubfolderName("");
                          setSelectedFiles([]);
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </>
      </div>
    </div>
  );
};

export default MembersHub;
